<template>
  <!-- Projects Table Column -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: 0 }"
  >
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">链接列表</h5>
        </a-col>
        <a-col
          :span="24"
          :md="12"
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <a-button type="primary" @click="addLinkModel = true">
            添加链接
          </a-button>
        </a-col>
      </a-row>
    </template>
    <a-table :columns="columns" :data-source="data" :pagination="pagination" :locale="locale">
      <template slot="type" slot-scope="type">
        <h6 class="m-0">
          <img :src="type.logo" width="25" style="margin-right: 10px" />
          {{ type.name }}
        </h6>
      </template>

      <template slot="link" slot-scope="link">
        <span>{{ link }}</span>
      </template>

      <template slot="editBtn" slot-scope="row">
        <a-popconfirm
          title="确定删除吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="deleteLink(row)"
        >
          <a-button
            type="link"
            :data-id="row.key"
            v-if="row.linkType == 'true'"
          >
            <svg
              t="1718638896210"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7771"
              width="20"
              height="20"
            >
              <path
                d="M566 332H458c-69.5 0-126-57.7-126-128.6v-30.9C332 101.7 388.5 44 458 44h108c69.5 0 126 57.7 126 128.6v30.9c0 70.8-56.5 128.5-126 128.5z m54-159.4c0-31.2-24.2-56.6-54-56.6H458c-29.8 0-54 25.4-54 56.6v30.9c0 31.2 24.2 56.6 54 56.6h108c29.8 0 54-25.4 54-56.6v-30.9zM728 980H296c-59.6 0-108-48.4-108-108V224h648v648c0 59.6-48.4 108-108 108z m36-684H260v576c0 19.8 16.2 36 36 36h432c19.8 0 36-16.2 36-36V296zM620 836V404h72v432h-72z m-144 0V404h72v432h-72z m-144 0V404h72v432h-72z m504-504H116v-72h36v-36c0-19.8 16.2-36 36-36h648c19.8 0 36 16.2 36 36v36h36v72h-72z"
                fill="#696969"
                p-id="7772"
              ></path>
            </svg>
          </a-button>
        </a-popconfirm>
        <a-button
          type="link"
          :data-id="row.key"
          @click="openCloakLlink"
          v-if="version == '3.0' && row.linkType == 'fake'"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="fill-gray-7"
              d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
            />
            <path
              class="fill-gray-7"
              d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
            />
          </svg>
        </a-button>

        <a-tag color="#f50" v-if="version != '3.0' && row.linkType == 'fake'">
          当前版本不支持
        </a-tag>
      </template>
    </a-table>
    <a-modal
      v-model="addLinkModel"
      title="添加跳转链接"
      centered
      cancelText="取消"
      okText="添加"
      @ok="addLink('true')"
    >
      <a-input placeholder="请输入跳转链接" v-model="newlink" />
    </a-modal>
    <a-modal
      v-model="editFakeModel"
      title="修改斗篷链接"
      centered
      cancelText="取消"
      okText="添加"
      @ok="cloakLink('fake')"
    >
      <a-input placeholder="请输入跳转链接" v-model="fakelink" />
    </a-modal>
  </a-card>
  <!-- / Projects Table Column -->
</template>

<script>
import { editLinks } from "@/api/index";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    locale: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Active button for the "Projects" table's card header radio button group.
      projectHeaderBtns: "all",
      addLinkModel: false,
      editFakeModel: false,
      version: "3.0",
      newlink: "",
      fakelink: "",
      pagination: {
        pageSize: 5,
      },
    };
  },
  methods: {
    addLink(type) {
      const urlPattern = new RegExp(
        "^(https?:\\/\\/)?" + // 协议
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // 域名
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // IP (v4) 地址
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // 端口和路径
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // 查询字符串
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // 锚点

      if (!urlPattern.test(this.newlink)) {
        this.$message.error("请输入合法链接！");
        this.newlink = "";
        return;
      }

      const links = this.data
        .filter((item) => item.linkType == "true")
        .map((item) => item.link);

      const newLinksArray = [...links, this.newlink];
      editLinks({
        type: type,
        links: newLinksArray,
      })
        .then((res) => {
          this.$emit("fetchLinks"); // 确保事件名称是字符串
          this.$message.success("链接更新成功！");
        })
        .catch((err) => {
          this.$message.error("更新链接失败！");
          console.error(err);
        });
      this.addLinkModel = false;
    },
    openCloakLlink() {
      this.fakelink = this.data
        .filter((item) => item.linkType == "fake")
        .map((item) => item.link);
      
      this.editFakeModel = true;
    },
    cloakLink(type) {
      const urlPattern = new RegExp(
        "^(https?:\\/\\/)?" + // 协议
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // 域名
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // IP (v4) 地址
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // 端口和路径
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // 查询字符串
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // 锚点

      if (!urlPattern.test(this.fakelink)) {
        this.$message.error("请输入合法链接！");
        this.newlink = "";
        return;
      }
      editLinks({
        type: type,
        links: [this.fakelink],
      })
        .then((res) => {
          this.$emit("fetchLinks"); // 确保事件名称是字符串
          this.$message.success("链接更新成功！");
        })
        .catch((err) => {
          this.$message.error("更新链接失败！");
          console.error(err);
        });
      this.addLinkModel = false;
    },
    deleteLink(delItem) {
      const links = this.data
        .filter((item) => item.link != "true" && item.link != delItem.link)
        .map((item) => item.link);
      editLinks({
        type: "true",
        links: links,
      })
        .then((res) => {
          this.$emit("fetchLinks"); // 确保事件名称是字符串
          this.$message.success("删除成功！");
        })
        .catch((err) => {
          this.$message.error("删除失败！");
          console.error(err);
        });
    },
  },
};
</script>